import { useState } from "react";

const COLLAPSED_CHAR_LIMIT = 180;

interface ExpandableTextProps {
  text: string | null | undefined;
  id: string;
}

export const ExpandableText = ({ text, id }: ExpandableTextProps) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) {
    return <span>-</span>;
  }

  const isLong = text.length > COLLAPSED_CHAR_LIMIT;
  const displayText =
    !isLong || expanded
      ? text
      : `${text.slice(0, COLLAPSED_CHAR_LIMIT).trim()}…`;

  return (
    <span>
      {displayText}
      {isLong && (
        <>
          {" "}
          <button
            className="btn btn-link p-0 align-baseline link-primary"
            id={id}
            type="button"
            onClick={() => setExpanded((current) => !current)}
          >
            {expanded ? "Vis mindre" : "Vis mere"}
          </button>
        </>
      )}
    </span>
  );
};
